export { default as ListadoReciboCuentaCobrar } from "./Listado";
